import React, { createContext, useState, useContext, ReactNode } from "react";

// Define the shape of the context
export interface LanguageContextType {
    language: string;
    switchLanguage: (lang: string) => void;
}

// Create the context with default values
export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Custom hook to use the Language context safely
export const useLanguage = (): LanguageContextType => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
};

// Define props for the provider
interface LanguageProviderProps {
    children: ReactNode;
}

// Language provider to wrap around your app
export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
    const [language, setLanguage] = useState<string>(localStorage.getItem("language") || "EN"); // Default language is English

    const switchLanguage = (lang: string) => {
        setLanguage(lang);
        localStorage.setItem("language", lang); // Store the language in localStorage for persistence
    };

    return <LanguageContext.Provider value={{ language, switchLanguage }}>{children}</LanguageContext.Provider>;
};
